// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start();
require("turbolinks").start();
require("@rails/activestorage").start();
require("channels");

require("select2");

require("jquery");
import "cocoon-js";
import "../trix-editor-overrides"
import "./sweet-alert-confirm";

// Datatables
var dt = require("datatables.net-dt");

window.jQuery = $;
window.$ = $;

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
const images = require.context("../images", true);
//const imagePath = (name) => images(name, true);

// Styles
import "css/main";

import { initQuotation, calcTotal, calculateSum , calcTotalByItem, stateRowsDiscount} from "./quotation";
import { initializeSelect2 } from "./autocomplete";

window.stateRowsDiscount = stateRowsDiscount
// Charts js

import { initializeChartPie } from "./charts";

document.addEventListener("turbolinks:before-cache", function () {

  $("#table-quotations").DataTable().destroy();
  $("#table-projects").DataTable().destroy();
  $("#table-projects-finished").DataTable().destroy();
  $("#table-products").DataTable().destroy();
});

document.addEventListener("turbolinks:load", () => {
  $.fn.dataTableExt.sErrMode = 'throw';
  if(window.current_discount==2){
    calcTotalByItem(true)
    calcTotalByItem(false)
  }else{
    calcTotal(true)
    calcTotal(false)
  }
  if (document.getElementById("income-pie")) {
    initializeChartPie("income-pie", "pie", true);
  }
  if (document.getElementById("quotations-by-state",)) {
    initializeChartPie("quotations-by-state");
    
    initializeChartPie("quotations-by-state-finance", "bar", true);
    initializeChartPie("quotations-by-client-finance", "bar", true);
    initializeChartPie("quotations-by-areas-finance", "bar", true);
  }
  if (document.getElementById("table-products")) {
    initializeDataTables("table-products", 10 , true);
  }

  if (document.querySelector("#items")) {
    initQuotation();

    // event insert or delete new item quotation
    $("#items")
      .on("cocoon:after-insert", function (e, task_to_be_added) {
        initializeSelect2(".quotation_quotation_items_item_id select");
      })
      .on("cocoon:before-remove", function (e, item) {
        item.addClass("hide");
      })
      .on("cocoon:after-remove", function () {
        if(window.current_discount == 1) {
          calcTotal(true)
          calcTotal(false)
        }else{
          calcTotalByItem(true)
          calcTotalByItem(false)
        }
      });
  }
  initializeSelect2(".quotation_quotation_items_item_id select");
});

// Modal events
import { openModal } from "./modal";
window.openModal = openModal;
window.initializeSelect2 = initializeSelect2;

// End modal events

require("trix");
require("@rails/actiontext");


// Datatables

import es from "./datatables.es.json";


function initializeDataTables(idTable, pageLenght = 10 , ordering = false, state = true, extraOptions = {}) {
  
  var baseOptions = {
    dom: "Bfrtip",
    ordering: ordering,
    paging: false,
    bLengthChange: false,
    language: es,
    stateSave: state,
  };

  var table = $(`#${idTable}`).DataTable(Object.assign(baseOptions, extraOptions));

  $(`#${idTable}_filter-input`).on("keyup", function () {
    let key = $(this).attr('id')
    let value = $(this).val()
    window.sessionStorage.setItem(key, value)
    table.search($(this).val()).draw();
  });

  return table;
}

window.initializeDataTables = initializeDataTables;

import "controllers"
